import { Observable } from 'rxjs';

export abstract class AuthRepository {
  abstract signInWithEmailAndPassword(email: string, password: string): Observable<Response>;
  abstract refreshToken(token: string): Observable<Response>;
}
